module.exports = __webpack_public_path__ + "img/CM-SL-CA-Volvo-Playful.cd48da1a.jpeg";